<template>
  <div>
    <a :id="id" :class="classes" v-on:click="openModal('modal')" :title="title">
      {{label}} <i v-if="icon" :class="iconClasses"></i>
    </a>

    <!-- Start Newsletter Modal -->
    <div ref="modal" class="modal" id="modal">
      <button class="btn close-button" v-on:click="closeModal('modal')" id="close-button"><i
          class="icon-close"></i></button>
      <div class="modal-content bg-brwn-lghtst p-0">
        <div class="modal--two-columns d-grid">
          <div class="modal--sidebar bg-brwn-lght">
            <small class="modal--sidebar-title p-4 text-xs-left mt-2">
              <span>{{ newsletterModalSidebarSubline }}</span>
              <span class="h-4 mt-1">{{ newsletterModalSidebarTitle }}</span>
            </small>
          </div>
          <div class="modal--form px-4 px-lg-5 py-5 align-item-center text-xl-left">
            <form @submit.prevent="submitForm" class="d-grid column-gap-2 row-gap-2">
              <h4 class="id-title">{{ newsletterModalHeading }}</h4>
              <label class="control checkbox id-blickpunkt">
                <input v-model="form.gppFocus" type="checkbox">
                <span class="control-indicator"></span>
                <strong>{{ newsletterModalTitle1 }}</strong>
                <br>
                <small><i>{{ newsletterModalDescription1 }}</i></small>
              </label>
              <label class="control checkbox id-newsletter mt-2">
                <input v-model="form.gppNewsletter" type="checkbox">
                <span class="control-indicator"></span>
                <strong>{{ newsletterModalTitle2 }}</strong>
                <br>
                <small><i>{{ newsletterModalDescription2 }}</i></small>
              </label>
              <div class="select id-salutation mt-3">
                <select v-model="form.salutation" aria-label="Anrede" required>
                  <option value="" disabled selected>Anrede*</option>
                  <option value="Frau">Frau</option>
                  <option value="Herr">Herr</option>
                </select>
              </div>
              <label class="id-name mt-lg-3">
                <input v-model="form.name" type="text" placeholder="Name*" required>
              </label>
              <label class="id-company">
                <input v-model="form.company" type="text" placeholder="Firma">
              </label>
              <label class="id-position">
                <input v-model="form.position" type="text" placeholder="Position">
              </label>
              <label class="id-email">
                <input v-model="form.email" type="email" placeholder="E-mail*" required>
              </label>
              <label class="control checkbox id-privacy mt-3">
                <input v-model="form.privacy" type="checkbox" aria-label="File browser" required>
                <span class="control-indicator"></span>
                <small>
                  <span>Ich habe die <a href="/privacy" target="_blank"
                      title="Datenschutzerklärung anzeigen">Datenschutzerklärung</a> für Newsletter gelesen und erkläre
                    mich damit einverstanden.</span>
                </small>
              </label>
              <div class="id-submit">
                <div
                  v-if="form.isCompleted"
                  class="valid-feedback justify-self-center mt-3 d-none_"
                >
                  Ihre Anmeldung wurde verschickt!
                </div>
                <input type="submit" :disabled="form.isCompleted" class="btn btn-primary mt-3" value="Anmelden">
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- End Newsletter Modal -->
  </div>
</template>
<script>
  import { load } from 'recaptcha-v3';

  import axios  from 'axios';
  import helpers from '../javascripts/helpers';

  // application/json is not supported by CORS
  axios.defaults.headers.post['Content-Type'] = 'text/plain';

  const recaptchaRenderParams = {
    explicitRenderParameters: {
      badge: 'bottomleft',
    },
  };

  export default {
    name: 'openAndCloseModal',
    props: [
      "classes",
      "label",
      "icon",
      "iconClasses",
      "id",
      "title",
      "newsletterModalSidebarSubline",
      "newsletterModalSidebarTitle",
      "newsletterModalHeading",
      "newsletterModalTitle1",
      "newsletterModalDescription1",
      "newsletterModalTitle2",
      "newsletterModalDescription2"],
    data() {
      return {
        form: {
          email: '',
          formName: 'Newsletter',
          company: '',
          salutation: '',
          position: '',
          privacy: '',
          gppFocus: '',
          gppNewsletter: '',
          isSending: false,
          isCompleted: false,
          isFailed: false,
        }
      }
    },
    methods: {
      openModal(evt) {
        this.$refs[evt].classList.toggle('open')
        this.$refs[evt].classList.toggle('closed')
      },
      closeModal(evt) {
        this.$refs[evt].classList.toggle('closed')
        this.$refs[evt].classList.toggle('open')
      },
      submitForm() {
        if (this.form.isSending || this.form.isCompleted) {
          return;
        }
        this.form.isSending = true;

        load(process.env.GRECAPTCHA_SITE_KEY, recaptchaRenderParams)
          .then((recaptcha) => {
            recaptcha.execute('homepage').then((token) => {
              const formData = helpers.extractFromData(this.form, token);
              axios
                .post(process.env.FORM_TARGET_URL, JSON.stringify(formData))
                .then(() => {
                  this.form.isCompleted = true;
                })
                .catch(() => {
                  this.form.isFailed = true;
                })
                .finally(() => {
                  this.form.isSending = false;
                });
            });
          });
      }
    },
  }
</script>
